import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18n from "./translations/i18n";
import { BrowserRouter as Router } from 'react-router-dom';
import { StyledEngineProvider } from '@mui/material';
import { portalCfg } from './config';

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Router basename={portalCfg.basename}>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </Router>
  </I18nextProvider>,
  document.getElementById('root')
);
if (process.env.NODE_ENV !== "development")
    console.log = () => {};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
